import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import extAxios from '../../services/extAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';
import { saveAs } from 'file-saver';

const state = {
    /* Remito base para duplicar */
    remitoId: 0, 
    cancelarRemito: false,
    remitoInterno: false,

    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    transporteId: 0,
    transporte: {},
    transporteNombre: null,
    entregaPersonal: false,

    // tipoRemitoNombre: 'REMITO (AFIP)',
    // tipoRemitoNombre: 'REMITO INTERNO',
    // tiposRemitosList: [ 'REMITO (AFIP)', 'REMITO INTERNO' ],

    // tipoEnvioId: 0,
    // tipoEnvio: null,
    // tipoEnvioNombre: null,
    // cantidad: 0,
    cantidadPaquetes: 0,
    cantidadBultos: 0,
    cantidadPallets: 0,
    valorDeclarado: 0,
    
    remitoDestinoId: 0,
    remitoDestino: {},
    remitoDestinoNombre: null,
    direccion: '',
    pais: '',
    provincia: '',
    localidad: '',
    codigoPostal: '',
    contacto: '',
    contactoTelefono: '',

    presupuestoInternoId: 0,
    presupuestoNumero: '',
    cliente: '',
    accion: '',
    ordenTrabajoId: 0,
    ordenTrabajo: '',
    ordenSubtrabajoId: 0,
    ordenSubtrabajo: '',

    observaciones: '',
    // presupuestosInternos: [],
    renglonesDescripcion: [],
    rowVersion: null,

    remitoDatos: [],
    remitoRenglonesDescripcionDatos: [],
    remitoPresupuestosInternosDatos: [],
    remitoEvaluacionDatos: [],

    remitoDatosRpt: [],
    remitoRenglonesDescripcionDatosRpt: [],

    cantidadRenglones: 30,
    cantidadRenglonesRemitoInterno: 35,

    // cantidadRenglones: 5,
    // cantidadRenglonesRemitoInterno: 10,

    /* Parametros para la actualización */
    remitoId: 0,
    remitoProximoNumero: 0,
    remitoFechaComprobante: moment(new Date()).format('YYYY-MM-DD'),

    imagenes: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_REMITO' (state, params) {
        state.remitoId = params.remitoId || 0;
        state.cancelarRemito = params.cancelarRemito || false;
        state.remitoInterno = params.remitoInterno;

        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD'),
        state.transporteId= 0;
        state.transporte= null;
        state.transporteNombre= null;
        state.entregaPersonal = false;
        // state.remitoInterno = false;
        // state.tipoEnvioId = 0;
        // state.tipoEnvio = null;
        // state.tipoEnvioNombre = null;
        // state.cantidad = 0;
        state.cantidadPaquetes = 0;
        state.cantidadBultos = 0;
        state.cantidadPallets = 0;
        state.valorDeclarado= 0;

        state.remitoDestinoId= 0;
        state.remitoDestino= null;
        state.remitoDestinoNombre= null;
        state.direccion = '';
        state.pais = '';
        state.provincia = '';
        state.localidad = '';
        state.codigoPostal = '';
        state.contacto = '';
        state.contactoTelefono = '';

        state.presupuestoInternoId = 0;
        state.presupuestoNumero = '';
        state.cliente = '';
        state.accion = '';
        state.ordenTrabajoId = 0;
        state.ordenTrabajo = '';
        state.ordenSubtrabajoId = 0;
        state.ordenSubtrabajo = '';
    
        state.observaciones = '';
        // state.presupuestosInternos = [];
        state.renglonesDescripcion = [];

        let cantidadRenglones = (/true/i).test(state.remitoInterno)? state.cantidadRenglonesRemitoInterno : state.cantidadRenglones;
        for (let index = 1; index <= cantidadRenglones; index++) {
            state.renglonesDescripcion.push({
                renglonNumero: index,
                cantidad: '',
                descripcion: '',
                importe: 0,
            });
        }

        state.rowVersion = null;
    },

    'SET_REMITO' (state, remito) {
        state.fechaComprobante = moment(remito.fechaComprobante).format('YYYY-MM-DD'),
        state.transporteId= remito.transporteId;
        state.transporte= remito.transporte;
        state.transporteNombre= remito.transporte? remito.transporte.nombre.trim() : null;
        state.entregaPersonal = remito.entregaPersonal;
        // state.remitoInterno = remito.remitoInterno;
        // state.tipoEnvioId = remito.tipoEnvio;
        // switch (remito.tipoEnvio) {
        //     case 1:
        //         state.tipoEnvio = { id: remito.tipoEnvio, nombre: 'PAQUETES' };
        //         state.tipoEnvioNombre = 'PAQUETES';
        //         break;
        //     case 2:
        //         state.tipoEnvio = { id: remito.tipoEnvio, nombre: 'BULTOS' };
        //         state.tipoEnvioNombre = 'BULTOS';
        //         break;
        //     case 3:
        //         state.tipoEnvio = { id: remito.tipoEnvio, nombre: 'PALLETS' };
        //         state.tipoEnvioNombre = 'PALLETS';
        //         break;
        // }
        // state.cantidad = remito.cantidad;
        state.cantidadPaquetes = remito.cantidadPaquetes;
        state.cantidadBultos = remito.cantidadBultos;
        state.cantidadPallets = remito.cantidadPallets;
        state.valorDeclarado= remito.valorDeclarado;

        state.remitoDestinoId= remito.remitoDestinoId;
        state.remitoDestino= remito.remitoDestino;
        state.remitoDestinoNombre= remito.remitoDestino? remito.remitoDestino.nombre.trim() : null;
        state.direccion = remito.direccion.trim();
        state.pais = remito.pais.trim();
        state.provincia = remito.provincia.trim();
        state.localidad = remito.localidad.trim();
        state.codigoPostal = remito.codigoPostal.trim();
        state.contacto = remito.contacto;
        state.contactoTelefono = remito.contactoTelefono;

        state.presupuestoInternoId = remito.presupuestoInternoId;
        state.presupuestoNumero = remito.presupuestoNumero;
        state.cliente = remito.cliente.trim();
        state.accion = remito.accion.trim();
        state.ordenTrabajoId = remito.ordenTrabajoId;
        state.ordenTrabajo = remito.ordenTrabajo? remito.ordenTrabajo.nombre.trim() : '';
        state.ordenSubtrabajoId = remito.ordenSubtrabajoId;
        state.ordenSubtrabajo = remito.ordenSubtrabajo? remito.ordenSubtrabajo.nombre.trim() : '';
    
        state.observaciones = remito.observaciones;
        // state.presupuestosInternos = [];
        state.renglonesDescripcion = [];

        let cantidadRenglones = (/true/i).test(remito.remitoInterno)? state.cantidadRenglonesRemitoInterno : state.cantidadRenglones;

        for (let index = 1; index <= cantidadRenglones; index++) {
            let cantidad = '';
            let descripcion = '';
            let importe = 0;

            if (remito.renglonesDescripcion) {
                let renglon = remito.renglonesDescripcion.find( r => r.renglonNumero == index);
                if (renglon) {
                    cantidad = renglon.cantidad.trim();
                    descripcion = renglon.descripcion.trim();
                }
            }
            
            state.renglonesDescripcion.push({
                renglonNumero: index,
                cantidad: cantidad,
                descripcion: descripcion,
                importe: importe,
            });
        }

        state.rowVersion = remito.rowVersion;
    },

    'SET_REMITO_DESTINO'(state, remitoDestino) {
        state.remitoDestino = remitoDestino;
        state.remitoDestinoId = remitoDestino? remitoDestino.id : 0;
        state.remitoDestinoNombre = remitoDestino? remitoDestino.nombre.trim() : null;
        /* Datos de entrega */
        state.direccion = remitoDestino? remitoDestino.direccion.trim() : '';
        state.localidad = remitoDestino? remitoDestino.localidad.trim() : '';
        state.provincia = remitoDestino? remitoDestino.provincia.trim() : '';
        state.pais = remitoDestino? remitoDestino.pais.trim() : '';
        state.codigoPostal = remitoDestino? remitoDestino.codigoPostal.trim() : '';
        state.contacto = remitoDestino? remitoDestino.nombre.trim() : '';
        state.contactoTelefono = remitoDestino? remitoDestino.telefono.trim() : '';
    },
    'SET_TRANSPORTE'(state, transporte) {
        state.transporte = transporte;
        state.transporteId = transporte? transporte.id : 0;
        state.transporteNombre = transporte? transporte.nombre.trim() : null;
    },
    'SET_ENTREGA_PERSONAL' (state) {
        if ((/true/i).test(state.entregaPersonal)) {
            state.transporte = null;
            state.transporteId = 0;
            state.transporteNombre = null;
        }
    },

    'SET_PRESUPUESTO_INTERNO'(state, params) {
        state.presupuestoInternoId = params.presupuestoInterno? params.presupuestoInterno.id : 0;
        state.presupuestoNumero = params.presupuestoInterno? params.presupuestoInterno.presupuestoNumero : '';
        state.cliente = params.presupuestoInterno? params.presupuestoInterno.cliente.trim() : '';
        state.accion = params.presupuestoInterno? params.presupuestoInterno.accion.trim() : '';
        state.ordenTrabajoId = params.ordenTrabajo? params.ordenTrabajo.id : 0;
        state.ordenTrabajo = params.ordenTrabajo? params.ordenTrabajo.rubroTrabajo.trim() : '';
        state.ordenSubtrabajoId = params.ordenSubtrabajo? params.ordenSubtrabajo.id : 0;
        state.ordenSubtrabajo = params.ordenSubtrabajo? params.ordenSubtrabajo.articuloTipo.trim() : '';
    },

    'SET_RENGLONES' (state, renglones) {
        let cantidadRenglones = (/true/i).test(state.remitoInterno)? state.cantidadRenglonesRemitoInterno : state.cantidadRenglones;
        state.renglonesDescripcion = [];
        for (let index = 1; index <= cantidadRenglones; index++) {
            let cantidad = '';
            let descripcion = '';
            let importe = 0;

            if (renglones) {
                if (renglones.length != 0) {
                    if (renglones.length >= index) {
                        let item = renglones[index - 1];
                        if (item) {
                            let renglon = item.split('\t');
                            if (renglon.length == 1) {
                                /* Si tiene una sola columna, la tomamos como descripcion */
                                /* 115 caracteres */
                                descripcion = renglon[0].substring(0, 115).trim();
                            } else if (renglon.length > 1) {
                                /* 5 caracteres */
                                cantidad = renglon[0].substring(0, 5).trim();
                                /* 115 caracteres */
                                descripcion = renglon[1].substring(0, 115).trim();
                            }
                        }
                    }
                }
            }
            
            state.renglonesDescripcion.push({
                renglonNumero: index,
                cantidad: cantidad,
                descripcion: descripcion,
                importe: importe,
            });
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.remitoDatos = [];
        state.remitoRenglonesDescripcionDatos = [];
        state.remitoPresupuestosInternosDatos = [];
        state.remitoEvaluacionDatos = [];
    },
    'SET_REMITO_DATOS' (state, params) {
        state.remitoDatos = params.remitoDatos;
        state.remitoRenglonesDescripcionDatos = params.remitoRenglonesDescripcionDatos;
        state.remitoPresupuestosInternosDatos = params.remitoPresupuestosInternosDatos;
        state.remitoEvaluacionDatos = params.remitoEvaluacionDatos;
    },
    'SET_REMITO_DATOS_RPT' (state, params) {
        state.remitoDatosRpt = params.remitoDatos;
        state.remitoRenglonesDescripcionDatosRpt = params.remitoRenglonesDescripcionDatos;
    },

    'INICIALIZAR_PARAMETROS_ACTUALIZACION' (state, remitoId)  {
        state.remitoId = remitoId;
        state.remitoProximoNumero = 0;
        state.remitoFechaComprobante = moment(new Date()).format('YYYY-MM-DD');
    },
    'SET_PARAMETROS_ACTUALIZACION' (state, params) {
        state.remitoProximoNumero = params.numero;
        state.remitoFechaComprobante = moment(params.fechaComprobante).format('YYYY-MM-DD');
    },

    'SET_IMAGENES' (state, imagenes) {
        state.imagenes = imagenes;
    },
    'ADD_IMAGEN' (state, imagen) {
        state.imagenes.push(imagen);
    },
    'REMOVE_IMAGEN' (state, imagenId) {
        let itemKey = state.imagenes
            .findIndex(imagen => imagen.id == imagenId);

        if (itemKey != -1) {
            state.imagenes.splice(itemKey, 1);
        }
    },
};

function validarRenglonesDescripcion(renglones) {
    let valid = true;
    
    /* Validamos que haya un renglon al menos con descripcion  */
    let itemKey = renglones
        .findIndex(renglon => renglon.descripcion.trim() != '');
    if (itemKey == -1) {
        valid = false;
    }
    
    return valid;
}

function validarLongitudRenglonesDescripcion(renglones) {
    let valid = true;
    
    renglones.forEach(renglon => {
        if (renglon.descripcion.length > 110) {
            valid = false;    
        }
    });

    return valid;
}

const getters = {
    getField,

    remitoDatosRpt (state) {
        return state.remitoDatosRpt;
    },
    remitoRenglonesDescripcionDatosRpt (state) {
        return state.remitoRenglonesDescripcionDatosRpt;
    }
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_REMITO', params);

            let loadRemito = false;
            if (params) {
                if (params.remitoId) {
                    if (params.remitoId != 0) {
                        loadRemito = true;
                    }
                }
            }

            if (loadRemito) {
                apiAxios.get(`remitos/${params.remitoId}/abm`)
                    .then(res => {
                        commit('SET_REMITO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })
    },
    setRemitoDestino: ({ commit }, remitoDestino) => {
        return new Promise((resolve, reject) => {
            commit('SET_REMITO_DESTINO', remitoDestino);
            resolve();
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })
    },
    setTransporte: ({ commit }, transporte) => {
        return new Promise((resolve, reject) => {
            commit('SET_TRANSPORTE', transporte);
            resolve();
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })
    },
    setEntregaPersonal: ({ commit }) => {
        return new Promise((resolve, reject) => {
            commit('SET_ENTREGA_PERSONAL');
            resolve();
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })
    },
    setPresupuestoInterno ( { commit }, params) {
        return new Promise((resolve, reject) => {
            commit('SET_PRESUPUESTO_INTERNO', params);
            resolve();
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })            
    },
    setRenglones ( { commit }, renglones) {
        return new Promise((resolve, reject) => {
            commit('SET_RENGLONES', renglones);
            resolve();
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (!validarRenglonesDescripcion(state.renglonesDescripcion)) {
                save = false;
                errorMessage = 'Verifique la información correspondiente a los renglones del comprobante.\n'
                    + 'Al menos un renglón debe contener una descripción.'
            }

            if (!validarLongitudRenglonesDescripcion(state.renglonesDescripcion)) {
                save = false;
                errorMessage = 'Verifique la información correspondiente a los renglones del comprobante.\n'
                    + 'La longitud de la descripción de cada renglón no puede superar los 115 caracteres.'
            }

            if (parseInt(state.cantidadPaquetes) == 0 & parseInt(state.cantidadBultos) == 0 & parseInt(state.cantidadPallets) == 0) {
                save = false;
                errorMessage = 'Debe ingresar la cantidad de paquetes, bultos o pallets del remito.'
            }

            if (save) {
                let remito= {
                    fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
                    transporteId: parseInt(state.transporteId),
                    // transporte: state.transporte,
                    entregaPersonal: (/true/i).test(state.entregaPersonal),
                    remitoInterno: (/true/i).test(state.remitoInterno),
                    // tipoEnvio: state.tipoEnvioId,
                    // cantidad: parseInt(state.cantidad),
                    cantidadPaquetes: parseInt(state.cantidadPaquetes),
                    cantidadBultos: parseInt(state.cantidadBultos),
                    cantidadPallets: parseInt(state.cantidadPallets),
                    valorDeclarado: parseFloat(state.valorDeclarado),
                    remitoDestinoId: parseInt(state.remitoDestinoId),
                    contacto: state.contacto.trim().toUpperCase(),
                    contactoTelefono: state.contactoTelefono.trim().toUpperCase(),

                    presupuestoInternoId: parseInt(state.presupuestoInternoId),
                    ordenTrabajoId: parseInt(state.ordenTrabajoId),
                    ordenSubtrabajoId: parseInt(state.ordenSubtrabajoId),

                    observaciones: state.observaciones.trim(),
                };

                remito.renglonesDescripcion = state.renglonesDescripcion
                    .filter(t => t.cantidad.toString().trim() != ''
                        || t.descripcion.toString().trim() != '');
                
                let url = 'remitos';
                if (state.remitoId != 0) {
                    url += '/' + state.remitoId + '/duplicar';
                }
                if ((/true/i).test(state.cancelarRemito)) {
                    url += '/delete';
                }

                apiAxios.post(url, remito)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },

    getDatos ( { commit }, remitoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (remitoId) {
                apiAxios.get(`remitos/${remitoId}` ) 
                    .then(res => {
                        let remitoDatos = [
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha de Ingreso', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                            { 'nombre': 'fechaComprobante', 'campo': 'Fecha de Comp.', 'valor': res.data.fechaComprobante, 'formato': 'fecha' },
                            { 'nombre': 'fechaAnulado', 'campo': 'Fecha Anulado', 'valor': res.data.fechaAnulado, 'formato': 'fecha' },
                            // { 'nombre': 'transporte', 'campo': 'Transporte', 'valor': res.data.transporte, 'formato': '' },
                            { 'nombre': 'formaEntrega', 'campo': 'Forma de Entrega', 'valor': res.data.formaEntrega, 'formato': '' },
                            { 'nombre': 'comprobante', 'campo': 'Nro.Comprobante', 'valor': res.data.comprobante, 'formato': '' },

                            { 'nombre': 'remitoDestino', 'campo': 'Destino', 'valor': res.data.remitoDestino, 'formato': '' },
                            { 'nombre': 'direccion', 'campo': 'Dirección', 'valor': res.data.direccion, 'formato': '' },
                            { 'nombre': 'pais', 'campo': 'Pais', 'valor': res.data.pais, 'formato': '' },
                            { 'nombre': 'provincia', 'campo': 'Provincia', 'valor': res.data.provincia, 'formato': '' },
                            { 'nombre': 'localidad', 'campo': 'Localidad', 'valor': res.data.localidad, 'formato': '' },
                            { 'nombre': 'codigoPostal', 'campo': 'Cod.Postal', 'valor': res.data.codigoPostal, 'formato': '' },
                            { 'nombre': 'contacto', 'campo': 'Contacto Remitente', 'valor': res.data.contacto, 'formato': '' },
                            { 'nombre': 'contactoTelefono', 'campo': 'Tel.Contacto', 'valor': res.data.contactoTelefono, 'formato': '' },

                            // { 'nombre': 'presupuestoInternoId', 'campo': 'Nro.Presupuesto', 'valor': res.data.presupuestoInternoId, 'formato': '' },
                            { 'nombre': 'presupuestoNumero', 'campo': 'Nro.Presupuesto', 'valor': res.data.presupuestoNumero, 'formato': '' },
                            { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': res.data.cliente, 'formato': '' },
                            { 'nombre': 'accion', 'campo': 'Accion', 'valor': res.data.accion, 'formato': '' },
                            { 'nombre': 'ordenTrabajo', 'campo': 'Orden de Trabajo', 'valor': res.data.ordenTrabajo, 'formato': '' },
                            { 'nombre': 'ordenSubtrabajo', 'campo': 'Subtrabajo', 'valor': res.data.ordenSubtrabajo, 'formato': '' },

                            // { 'nombre': 'tipoEnvio', 'campo': 'Tipo de Envío', 'valor': tipoEnvio, 'formato': '' },
                            // { 'nombre': 'cantidad', 'campo': 'Cantidad', 'valor': res.data.cantidad, 'formato': '' },
                            { 'nombre': 'cantidadPaquetes', 'campo': 'Cantidad Paquetes', 'valor': res.data.cantidadPaquetes, 'formato': '' },
                            { 'nombre': 'cantidadBultos', 'campo': 'Cantidad Bultos', 'valor': res.data.cantidadBultos, 'formato': '' },
                            { 'nombre': 'cantidadPallets', 'campo': 'Cantidad Pallets', 'valor': res.data.cantidadPallets, 'formato': '' },
                            { 'nombre': 'valorDeclarado', 'campo': 'Valor Declarado', 'valor': res.data.valorDeclarado, 'formato': 'moneda' },

                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones, 'formato': '' },
                        ]

                        let remitoEvaluacionDatos = [];
                        if ((/true/i).test(res.data.noEvaluar)) {
                            remitoEvaluacionDatos.push(
                                { 'nombre': 'evaluacion', 'campo': 'No Evaluar (Transporte)', 'valor': '', 'formato': '' },
                            )
                        }
                        if ((/true/i).test(res.data.evaluado)) {
                            remitoEvaluacionDatos.push(
                                { 'nombre': 'fechaEvaluacion', 'campo': 'Fecha Evaluación', 'valor': res.data.fechaNoEvaluacion, 'formato': 'fechaHora' },
                                { 'nombre': 'calificacionEvaluacion', 'campo': 'Calificación', 'valor': res.data.calificacionEvaluacion, 'formato': '' },
                                { 'nombre': 'usuarioEvaluacion', 'campo': 'Usuario', 'valor': res.data.usuarioEvaluacion, 'formato': '' },
                                { 'nombre': 'observacionesEvaluacion', 'campo': 'Observaciones', 'valor': res.data.observacionesEvaluacion, 'formato': '' }
                            )
                        }

                        let params = {
                            remitoDatos,
                            remitoRenglonesDescripcionDatos: res.data.renglonesDescripcion,
                            remitoPresupuestosInternosDatos: res.data.presupuestosInternos,
                            remitoEvaluacionDatos
                        }
                                      
                        commit('SET_REMITO_DATOS', params);
                        resolve();
                    })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
            }
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })            
    },
    getDatosRpt ( { commit }, remitoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (remitoId) {
                apiAxios.get(`remitos/${remitoId}` ) 
                    .then(res => {
                        let params = {
                            remitoDatos: res.data,
                            remitoRenglonesDescripcionDatos: res.data.renglonesDescripcion
                        }
                                      
                        commit('SET_REMITO_DATOS_RPT', params);
                        resolve();
                    })
                .catch(error => helpers.methods.getErrorMessage(error));
            }
        })            
    },
    inicializarParametrosActualizacion ({ commit }, remitoId) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PARAMETROS_ACTUALIZACION', remitoId);

            apiAxios.get('remitos/params')
                .then(res => {
                    commit('SET_PARAMETROS_ACTUALIZACION', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(helpers.methods.getErrorMessage(error));
        })
    },
    actualizarNumeracion ( { state } ) {
        return new Promise((resolve, reject) => {
            let remitoParams= {
                numero: state.remitoProximoNumero,
                fechaComprobante: moment(state.remitoFechaComprobante).format('YYYY-MM-DD'),
            };

            apiAxios.post(`remitos/${state.remitoId}/actualizar`, remitoParams)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    actualizarEstado ( {}, params ) {
        return new Promise((resolve, reject) => {
            let url = `remitos/${params.remitoId}/actualizar-estado`;

            let remitoActualizacion = {
                remitoEstadoId: params.remitoEstadoId
            };

            if (params.remitoId == 0) {
                url = 'remitos/actualizar-estado';

                if (params.remitos) {
                    remitoActualizacion.remitos = params.remitos.map(remito => ({
                        id: remito.remitoId
                    }))
                }
            }

            apiAxios.post(url, remitoActualizacion)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    actualizarDespacho ( {}, params ) {
        return new Promise((resolve, reject) => {
            let url = `remitos/${params.remitoId}/actualizar-despacho`;

            let remitoActualizacion = {
                fechaDespacho: moment(params.fechaDespacho).format('YYYY-MM-DD'),
                fechaEntregaEstimada: moment(params.fechaEntregaEstimada).format('YYYY-MM-DD'),
                actualizarEstado: (/true/i).test(params.actualizarEstado),
            };

            if (params.remitoId == 0) {
                url = 'remitos/actualizar-despacho';

                if (params.remitos) {
                    remitoActualizacion.remitos = params.remitos.map(remito => ({
                        id: remito.remitoId
                    }))
                }
            }

            apiAxios.post(url, remitoActualizacion)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    actualizarEntrega ( {}, params ) {
        return new Promise((resolve, reject) => {
            let url = `remitos/${params.remitoId}/actualizar-entrega`;

            let remitoActualizacion = {}
            if ((/true/i).test(params.entregaEstimada)) { 
                url = `remitos/${params.remitoId}/actualizar-entrega-estimada`;
                remitoActualizacion.fechaEntregaEstimada = moment(params.fechaEntregaEstimada).format('YYYY-MM-DD')
            } else {
                remitoActualizacion.fechaEntrega = moment(params.fechaEntrega).format('YYYY-MM-DD');
                remitoActualizacion.actualizarEstado = (/true/i).test(params.actualizarEstado);
            }

            if (params.remitoId == 0) {
                url = 'remitos/actualizar-entrega';
                if ((/true/i).test(params.entregaEstimada)) { 
                    url = 'remitos/actualizar-entrega-estimada';
                }

                if (params.remitos) {
                    remitoActualizacion.remitos = params.remitos.map(remito => ({
                        id: remito.remitoId
                    }))
                }
            }

            apiAxios.post(url, remitoActualizacion)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    agregarAnulado ( { state } ) {
        return new Promise((resolve, reject) => {
            let remitoParams= {
                numero: state.remitoProximoNumero,
                fechaComprobante: moment(state.remitoFechaComprobante).format('YYYY-MM-DD'),
                observaciones: ''
            };

            apiAxios.post('remitos/agregar-anulado', remitoParams)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getImagenes: ( { commit }, params ) => {
        return new Promise((resolve, reject) => {
            apiAxios.get(`remitos/${params.remitoId}/imagenes` ) 
                .then(res => {
                    commit('SET_IMAGENES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addImagen ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            let error;
            let fileName = params.file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(params.file.size / 1048576);

            if (fileExtension != 'jpg' 
                & fileExtension != 'png'
                & fileExtension != 'jpeg'
                & fileExtension != 'pdf') {
                    error = 'El tipo de archivo seleccionado no es válido. Sólo se permiten imágenes de tipo jpg, png o jpeg.';
            }

            if (fileSize >= 3 ) {
                error = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten imágenes de hasta 3MB.';
            }

            if (error) {
                reject(error);
            } else {
				let formData = new FormData();
                formData.append('file', params.file);

                let options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }				

				apiAxios.post(`remitos/${params.remitoId}/imagenes`, formData, options)
                    .then(res => {
                        commit('ADD_IMAGEN', res.data);
                        resolve();
                    })
					.catch(error => reject(helpers.methods.getErrorMessage(error)));
			}
        })
    },	
    removeImagen ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`remitos/${params.remitoId}/imagenes/${params.imagenId}/delete`)
                .then(() => {
					commit('REMOVE_IMAGEN', params.imagenId);
					resolve();
				})
				.catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    descargarImagenes: ( {}, remitoId ) => {
        return new Promise((resolve, reject) => {
            apiAxios.get(`remitos/${remitoId}/imagenes/descargar` ) 
                .then(res => {
                    if (res.data == '') {
                        reject('El remito no tiene archivos asociados.')
                        return null;
                    }
                    
                    return extAxios.get(res.data, {responseType: 'blob'});
                })
                .then(res => {
                    if (res) {
                        saveAs(res.data, 'download.zip');
                    }
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}